import { additionalTranslationsResources } from '@sbercloud/common-translations';
import { LocaleProvider } from '@sbercloud/uikit-product-locale';
import { PropsWithChildren } from 'react';

export function WithLocale({ children }: PropsWithChildren) {
  return (
    <LocaleProvider lang='ru-RU' additionalTranslationsResources={additionalTranslationsResources}>
      {children}
    </LocaleProvider>
  );
}
